import EditBookingFormInfantRow from './EditBookingFormInfantRow'

export default EditBookingFormInfantRow
